import CONSTANTS from '@/shared/constants/constants'

export function canShowExamSoc(details) {
  if (!details.socAtivo || !details.speciality) return false
  return Number(details.speciality.id) === CONSTANTS.SPECIALITY.HOLTER
}

export function initialSocState(details) {
  const portalSocId = Number(details.portalSocId) > 0 ? Number(details.portalSocId) : null
  return {
    portalSocId
  }
}
